const EXCLUDED_PATTERNS = [
  "placement readiness program",
  "placement readiness",
  "sw process & quality skill development",
  "process & quality skill development",
];

const RENAME_RULES: Array<{ pattern: RegExp; replacement: string }> = [
  { pattern: /paid internship/gi, replacement: "Applied Internship" },
];

const isStringMatch = (value: string): boolean => {
  const normalized = value.toLowerCase();
  return EXCLUDED_PATTERNS.some((pattern) => normalized.includes(pattern));
};

const collectCandidateStrings = (service: unknown): string[] => {
  if (!service || typeof service !== "object") {
    return [];
  }

  const candidates: string[] = [];
  const stack: unknown[] = [service];

  while (stack.length) {
    const current = stack.pop();
    if (!current || typeof current !== "object") continue;

    for (const value of Object.values(current)) {
      if (typeof value === "string") {
        candidates.push(value);
      } else if (value && typeof value === "object") {
        stack.push(value);
      }
    }
  }

  return candidates;
};

const applyRenameRules = (value: string): string =>
  RENAME_RULES.reduce((acc, { pattern, replacement }) => acc.replace(pattern, replacement), value);

const renameServiceStrings = <T>(service: T): T => {
  const stack: unknown[] = [service];

  while (stack.length) {
    const current = stack.pop();

    if (current == null) {
      continue;
    }

    if (Array.isArray(current)) {
      for (let index = 0; index < current.length; index += 1) {
        const item = current[index];
        if (typeof item === "string") {
          current[index] = applyRenameRules(item) as (typeof current)[number];
        } else if (item && typeof item === "object") {
          stack.push(item);
        }
      }
      continue;
    }

    if (typeof current !== "object") {
      continue;
    }

    const record = current as Record<string, unknown>;
    for (const key of Object.keys(record)) {
      const value = record[key];
      if (typeof value === "string") {
        record[key] = applyRenameRules(value);
      } else if (value && typeof value === "object") {
        stack.push(value);
      }
    }
  }

  return service;
};

export const isServiceExcluded = (service: unknown): boolean =>
  collectCandidateStrings(service).some(isStringMatch);

export const filterExcludedServices = <T>(services: T[]): T[] =>
  services
    .map((service) => renameServiceStrings(service))
    .filter((service) => !isServiceExcluded(service));
